import React, { useMemo } from "react";
import "./style.css";

const Coordinate = ({ latitude, longitude, visibility = true }) => {
  const withCoords = latitude && longitude;

  const content = useMemo(() => {
    const locationText = withCoords
      ? `${latitude}, ${longitude}`
      : "No lat/long available";

    const className = visibility
      ? "photo-coordinate-text"
      : "photo-coordinate-text-hidden";

    return <span className={className}>{locationText}</span>;
  }, [latitude, longitude, visibility, withCoords]);

  if (withCoords && visibility) {
    return (
      <a
        href={`https://www.google.com/maps?q=${latitude},${longitude}`}
        target="_blank"
        rel="noopener noreferrer"
        className="photo-coordinate-link">
        {content}
      </a>
    );
  }

  return content;
};

export default Coordinate;
